<template>
  <section>
    <h2 class="h2Title">모임 일정</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl class="infoCont">
                <dd class="formInfoArea">
                  <v-col class="mgr" sm="6">
                    <div class="d-flex">
                      <ul v-for="(t) in parentGroups" :key="t.value">
                        <v-checkbox v-model="searchParentGroup" :value="t.groupId" :label="t.groupName" hide-details></v-checkbox>
                      </ul>
                    </div>
                  </v-col>
                </dd>

                <dd class="formInfoArea">
                    <v-select :items="clubItems" item-value="groupId" item-text="groupName" v-model="searchGroup"
                              dense clearable outlined flat hide-details label="선택" v-if="searchParentGroup === 2" @change="search(param)"/>

                    <v-select :items="departmentItems" item-value="groupId" item-text="groupName" v-model="searchGroup"
                              dense clearable outlined flat hide-details label="선택" v-if="searchParentGroup === 1" @change="search(param)"/>
                </dd>
              </dl>

              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 / 장소 / 주소 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>

    <article class="tableWrap">
      <div class="tableBx">
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar
                  flat
              >
                <v-btn
                    outlined
                    class="mr-4"
                    color="grey darken-2"
                    @click="setToday"
                >
                  Today
                </v-btn>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="prev"
                >
                  <v-icon small>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="next"
                >
                  <v-icon small>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'month'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-month</v-icon>
                  월
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'week'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-week</v-icon>
                  주
                </v-btn>
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'day'" color="primary" dark>
                  <v-icon left>mdi mdi-calendar-today</v-icon>
                  일
                </v-btn>
<!--                <v-btn class="vBtn vIconResize mgr" @click="customCalendarType" color="primary" dark>-->
<!--                  <v-icon left>mdi mdi-calendar-minus</v-icon>-->
<!--                  3일-->
<!--                </v-btn>-->
                <!--                    <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = '4day'" color="primary" dark>-->
                <!--                      <v-icon left>mdi mdi-calendar-minus</v-icon>-->
                <!--                      4일-->
                <!--                    </v-btn>-->
                <v-btn class="vBtn vIconResize mgr" @click="calOptions.type = 'category'" color="primary" dark>
                  <v-icon left>mdi mdi-group</v-icon>
                  그룹
                </v-btn>


<!--                <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: 'meeting/form'})" color="#666" dark>-->
<!--                  <v-icon left>mdi mdi-playlist-plus</v-icon>-->
<!--                  등록-->
<!--                </v-btn>-->
              </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
              <v-calendar
                  ref="calendar"
                  v-model="calOptions.focus"
                  color="primary"
                  :start="calOptions.start"
                  :end="calOptions.end"
                  :events="schedules"
                  :event-color="getEventColor"
                  :event-more="calOptions.more"
                  :type="calOptions.type"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="search"
                  category-show-all
                  :categories="calOptions.categories"
              >

                <template v-slot:day-label="{ past, date, day, present, weekday }">
                  <template v-if="true">
                    <div class="v-calendar-weekly__day-label d-flex">
                      <v-btn
                              small rounded fab depressed
                              class="has-bg transparent"
                              :color="present ? 'primary' : 'white'"
                              :dark="present"
                              @click="viewDay"
                      >
                        <span class="v-btn__content" :style="present ? 'color:primary' : weekday === 0 || holidays.filter(h => h.formatDate === date).length > 0 ? 'color:red' : weekday === 6 ? 'color:blue' : 'color:black'">{{ day }}</span>
                      </v-btn>

                      <div class="v-event v-event-start v-event-end pl-1" style="padding-top:10px" v-if="holidays.filter(h => h.formatDate === date).length > 0">{{holidays.filter(h => h.formatDate === date)[0].dateName}}</div>

                    </div>
<!--                    <button type="button" class="v-btn v-btn--depressed v-btn--fab v-btn--rounded theme--light v-size--default grey"><span class="v-btn__content">55 추석 연휴</span></button>-->
<!--                    <button type="button" class="v-btn v-btn--depressed v-btn--fab v-btn--round theme--light v-size--small transparent"><span class="v-btn__content">a</span></button>-->
<!--                    {{ present }}-->
<!--                    {{ past }}-->
<!--                    {{ date }}-->
                  </template>
                </template>
<!--                <template v-slot:day="{ date, week, weekday }">-->
<!--                  <template-->
<!--                      class="orange&#45;&#45;text orange"-->

<!--                  >-->
<!--                    <v-sheet-->
<!--                        key="i"-->
<!--                        title="vvv"-->
<!--                        style="background-color: powderblue"-->
<!--                        width="100%"-->
<!--                        height="100%"-->
<!--                        tile-->
<!--                    >{{date}} {{week.weekday}} ( {{weekday}} )</v-sheet>-->
<!--                  </template>-->
<!--                </template>-->
<!--                <template v-slot:day-label="{ date, }">-->
<!--                  <template-->
<!--                      class="orange&#45;&#45;text orange"-->
<!--                      style="background-color: powderblue"-->
<!--                  >-->
<!--                    <v-sheet-->
<!--                        key="i"-->
<!--                        title="vvv"-->
<!--                        style="background-color: powderblue"-->
<!--                        width="100%"-->
<!--                        height="100%"-->
<!--                        tile-->
<!--                    >-->
<!--                   &#45;&#45;{{date}}&#45;&#45;-->
<!--                    </v-sheet>-->
<!--                  </template>-->
<!--                </template>-->
<!--                <template v-slot:day-label-header="{ date }">-->
<!--                  <template-->
<!--                      class="orange&#45;&#45;text orange"-->
<!--                      style="background-color: powderblue"-->
<!--                  >-->
<!--                    <v-sheet-->
<!--                        key="i"-->
<!--                        title="vvv"-->
<!--                        style="background-color: powderblue"-->
<!--                        width="100%"-->
<!--                        height="100%"-->
<!--                        tile-->
<!--                    >-->
<!--                    &#45;&#45;{{date}}&#45;&#45;-->
<!--                    </v-sheet>-->
<!--                  </template>-->
<!--                </template>-->

              </v-calendar>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </article>

  </section>
</template>

<script>
import meetingApi from '@/api/MeetingApi'
import groupApi from '@/api/GroupApi'
import utilApi from "@/api/UtilApi";

export default {
  name: "MeetingSchedule",
  data: () => ({
    param: {
      searchDate:[],
      searchState: null,
      searchRole: null,
      searchKeyword: null,
      page: 1,
      start: {},
      end: {}
    },
    schedules: [],
    totalItems: 0,
    dialogVisible: false,
    waitingSearch: false,
    board: {},
    options:{},
    calOptions:{
      focus: '',
      type: 'month',
      more: true,
      categories: ['분과', '동호회', '사무국'],
      intervalsDefault : {
        first: 0,
        minutes: 60,
        count: 24,
        height: 40
      }
    },
    events: [],
    parentGroups: [],
    departmentItems: [],
    clubItems: [],
    searchParentGroup: null,
    holidays: []
  }),
  watch: {
    'param.searchKeyword': {
      handler(nv, ov) {
        if(nv === ov)
          return;

        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search(this.param);
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    searchParentGroup: {
      handler(nv, ov) {
        if(nv !== null && nv === ov)
          return;
        if(nv !== null && nv === this.param.searchParentGroup)
          return;

        this.param.searchParentGroup = null;
        if(nv === null || ov === 3) {
          this.param.searchGroup = null;
        }
        if(nv === 3) {
          this.param.searchGroup = 3;
        } else {
          this.param.searchParentGroup = nv;
        }
        this.search(this.param);
      },
      deep: true
    }
  },
  computed: {
    searchGroup: {
      get() {
        return this.param.searchGroup;
      },
      set(v) {
        this.param.searchGroup = v;
      }
    }
  },
  methods: {
    customCalendarType() {
      this.calOptions.type = 'custom-daily'
      const day = this.calOptions.focus && this.calOptions.focus !== '' ? this.$moment(this.calOptions.focus).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD');
      this.calOptions.start = day;
      this.calOptions.end = this.$moment(day).add(2, 'd').format('YYYY-MM-DD');
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
      // watch param.searchDate
    },
    async search({ start, end }) {

      const startMonth = this.$moment(start.date).format('YYYY-MM');
      await this.getHolidays(startMonth.split('-')[0], startMonth.split('-')[1]);

      let params = {...this.param, ...{
            page: 1,
            size: -1,
            start,
            end,
            searchStartDt: this.$moment(start.date).add(-7, 'days').format('YYYY-MM-DD'),
            searchEndDt: this.$moment(end.date).add(7, 'days').format('YYYY-MM-DD')
      }};
      const colors =  ['deep-purple', '#ffab3d', '#ff6969', '#526de1', 'blue', 'green', 'orange', 'cyan', 'grey darken-1', 'indigo']

      meetingApi.list(params).then(data => {

        this.totalItems = data.totalElements;
        this.schedules = data.content.map(m => {
          return Object.assign(m, {
            name: m.title,
            start: this.$moment(`${m.startDt} ${m?.startTm?? '00:00:00'}`, 'YYYY-MM-DD HH:mm:ss').toDate(),// ? m.startDt + (m.startTm ? ' ' + m.startTm.substr(0, 5) : '') : null,
            end: this.$moment(`${m.endDt} ${m?.endTm?? '00:00:00'}`, 'YYYY-MM-DD HH:mm:ss').toDate(), // ? m.endDt + (m.endTm ? ' ' + m.endTm.substr(0, 5) : '') : null,
            color: colors[m.group?.parent?.groupId??m.groupId],
            // color: colors[this.rnd(0, colors.length - 1)],
            timed: m.startTm && m.endTm,
            category:this.calOptions.categories[(m.group?.parent?.groupId??m.groupId)-1]
          });
        });//.filter(m => m.start !== null && m.end !== null);

        // this.$refs.calendar.scrollToTime('14:00')
        this.$refs.calendar.scrollToTime({hour: 13, minute: 0});
        this.$store.commit('setParams', params);

      });
    },
    setToday () {
      this.calOptions.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getEventColor (event) {
      return event.color
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    viewDay ({ date }) {
      this.calOptions.focus = date
      this.calOptions.type = 'day'
    },
    showEvent ({ event }) {
      this.$router.push({path:`/group/meeting/form/${event.meetingId}`});
    },
    getHolidays(year, month) {
      utilApi.holidays(year, month).then(data => {
        this.holidays = data;
        // console.log(this.holidays);
      })
    }
  },
  mounted() {
    const toMonth = this.calOptions.focus && this.calOptions.focus !== '' ? this.$moment(this.calOptions.focus).format('YYYY-MM') : this.$moment().format('YYYY-MM');
    this.getHolidays(toMonth.split('-')[0], toMonth.split('-')[1]);
  },
  created: function () {
    const storedParams = this.$store.getters?.params??{};
    this.searchParentGroup = storedParams.searchParentGroup;
    this.param.searchGroup = storedParams.searchGroup;
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }


    groupApi.flatList().then(data => {
      // console.log(data);
      this.parentGroups = data.filter(d => d.activated);
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });

    // console.log(this.$store.state.currentMenu)
    // console.log(this.$store.getters.menu)
    // console.log(this.$store.getters.params)

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
